import { useCallback } from "react";
import { useSelector } from "react-redux";
import { castArray, some } from "lodash";

// Generic RBAC hook. Reads user.data.permissions from Redux (the same map
// used by src/router/routeGuard.js and src/const/links.js: an object where
// each granted permission key is set to `true`) and exposes helpers to check
// one or more permission strings.
//
// Usage:
//   const { hasPermission, hasAnyPermission } = usePermission();
//   if (hasPermission("analytics:messages:view")) { ... }
const usePermission = () => {
  const permissions = useSelector((state) => state.user?.data?.permissions);

  const hasPermission = useCallback(
    (permission) => !!permissions && !!permissions[permission],
    [permissions]
  );

  const hasAnyPermission = useCallback(
    (requiredPermissions) =>
      !!permissions &&
      some(castArray(requiredPermissions), (permission) => permissions[permission]),
    [permissions]
  );

  return { permissions, hasPermission, hasAnyPermission };
};

export default usePermission;
